import { combineReducers } from 'redux';
import { Map } from 'immutable';
import data from './data/reducer';
import core from './core';

const MIDDLEWARE_INITIAL_STATE = new Map();

function middleware(state = MIDDLEWARE_INITIAL_STATE, action) {
    switch (action.type) {
        case 'FHE__MIDDLEWARE_SET_CONNEXION_STATE':
            return core.setMiddlewareConnectionState(state, action.state, action.mid, action.label);
    }
    return state;
}

const GROUPID_INITIAL_STATE = new Map({
    clientInterface: null,
    groupId: null,
    assigneeIds: null,
    code: null
});

function config(state = GROUPID_INITIAL_STATE, action) {
    switch (action.type) {
        case 'FHE_SET_CLIENTINTERFACE':
            return core.setClientInterface(state, action.clientInterface);
        case 'FHE_GIT__SET_GROUPID':
            return core.setGroupId(state, action.groupId);
        case 'FHE_GIT__SET_ASSIGNEEIDS':
            return core.setAssigneeIds(state, action.assigneeIds);
        case 'FHE_SET_CONFIG':
            return core.setConfig(state, action.config);
    }
    return state;
}

export default combineReducers({
    config,
    middleware,
    data
});



// WEBPACK FOOTER //
// ./environments/fhe/reducer.js